import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Spinner from "src/components/Spinner";
import { formatAmount, sanitizeNumericString } from "src/utils/formatters";

const JACKPOT_API_URL =
  "https://script.google.com/macros/s/AKfycbyYkWlmnSNYEw9sC6xylMaK0uGo8_ao8qiBG1g-_OVlDweXk7SZ7Yb-IQatEywWf9je/exec";

const DEFAULT_JACKPOT_AMOUNT = "$100,000";

const formatJackpotAmount = (value) => {
  const cleaned = sanitizeNumericString(value);
  const formatted = formatAmount(cleaned, "en");
  return formatted || DEFAULT_JACKPOT_AMOUNT;
};

const getJackpotAmount = (data) => {
  if (data && typeof data === "object" && !Array.isArray(data)) {
    return formatJackpotAmount(
      data.amount ?? data.value ?? data.jackpot ?? data.prize
    );
  }

  return formatJackpotAmount(data);
};

const CashnadoAugust2026TV = () => {
  const [jackpotAmount, setJackpotAmount] = useState(DEFAULT_JACKPOT_AMOUNT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJackpotAmount = async () => {
      try {
        const timestamp = Date.now();
        const response = await fetch(`${JACKPOT_API_URL}?t=${timestamp}`);
        const rawText = await response.text();

        let data;
        try {
          data = JSON.parse(rawText);
        } catch {
          data = rawText;
        }

        setJackpotAmount(getJackpotAmount(data));
      } catch (error) {
        console.error("Error fetching Cashnado August 2026 TV data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchJackpotAmount();
    const interval = setInterval(fetchJackpotAmount, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <TVContainer>
      <BackgroundVideo autoPlay muted loop playsInline>
        <source
          src="/videos/Prorgressive-Jackpot-Cashnado-August-2026.mp4"
          type="video/mp4"
        />
      </BackgroundVideo>

      <AmountOverlay>
        {loading ? <Spinner variant="dark" /> : jackpotAmount}
      </AmountOverlay>
    </TVContainer>
  );
};

const TVContainer = styled.div`
  width: min(100vw, calc(100vh * 16 / 9));
  aspect-ratio: 16 / 9;
  margin: 0 auto;
  background-color: #000;
  color: white;
  overflow: hidden;
  position: relative;
`;

const BackgroundVideo = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const AmountOverlay = styled.div`
  position: absolute;
  left: 50%;
  top: 50.5%;
  transform: translate(-50%, -50%) scaleX(1.12);
  z-index: 2;
  width: 84%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ad790b;
  font-family: "Poppins", sans-serif;
  font-size: min(11.8vw, 21vh);
  font-weight: 900;
  line-height: 0.9;
  white-space: nowrap;
  -webkit-text-stroke: min(0.18vw, 0.32vh) #fff;
  text-shadow: 0 min(0.27vw, 0.48vh) 0 #604000;

  .spinner {
    transform: scaleX(0.89);
  }
`;

export default CashnadoAugust2026TV;